// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3K5w-","right":"styles_right__SF3td"};